"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createHTML = createHTML;

var _constants = require("../constants");

function createHTML(html) {
  var replaced = html;
  replaced = replaced.replace(/0 1 100% fill/g, "0 1 100%");
  var str = _constants.htmlStrBefore + replaced + _constants.htmlStrAfter;
  str = str.replace("&lt;", "<").replace("&gt;", ">");
  return str;
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/commonFunctions.js
// module id = 828
// module chunks = 0